import script from "./bulkConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./bulkConfirmModal.vue?vue&type=script&setup=true&lang=js"

import "./bulkConfirmModal.vue?vue&type=style&index=0&id=8b4c106e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b4c106e"]])

export default __exports__